module.exports = __webpack_public_path__ + "img/05.305a3865.png";